import { FaApple, FaGooglePlay } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { SocialLinks } from ".";
import { ROUTES } from "../../utils/routes";
import StoreButton from "../store-button.component";

const Container = styled.div`
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;

  div.flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  span {
    &:nth-child(3) {
      margin: 2rem 0;
    }
  }
`;

const buttonProps = {
  colorSub: "#cbd1d7",
  colorMain: "#ffffff",
  hoverColorMain: "#1C344F",
  hoverColorSub: "#5C6A78",
  bgColor: "none",
  hoverBgColor: "#ffffff",
  iconColor: "#ffffff",
  hoverIconColor: "#1C344F",
  borderColor: "#748595",
  hoverBorderColor: "#ffffff",
};

export const MobileFooter = () => {
  return (
    <Container>
      <span>
        <Link to={ROUTES.terms_of_service}>Terms of Service</Link>
      </span>

      <span>
        <Link to={ROUTES.privacy_policy}>Privacy Policy</Link>
      </span>

      <span>
        <SocialLinks />
      </span>

      <div className="flex">
        <span>
          <StoreButton
            {...buttonProps}
            storeName="App Store"
            icon={<FaApple className="icon" />}
          />
        </span>

        <span>
          <StoreButton
            {...buttonProps}
            storeName="Google Play"
            icon={<FaGooglePlay className="icon" />}
          />
        </span>
      </div>

      <span>© 2022 Recyclo | All Rights Reserved</span>
    </Container>
  );
};
